/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CapabilityType } from './capabilityType';
import { MedicalExaminationApiModel } from './medicalExaminationApiModel';
import { CapabilityEligibleIntervalApiModel } from './capabilityEligibleIntervalApiModel';


export interface CapabilityMedicalExaminationApiModel { 
    id: number;
    code: string;
    category?: number | null;
    mandatory: boolean;
    guid: string;
    type: CapabilityType;
    name: string;
    specification: string;
    eligibleIntervals: Array<CapabilityEligibleIntervalApiModel>;
    medicalExaminations: Array<MedicalExaminationApiModel>;
}
export namespace CapabilityMedicalExaminationApiModel {
}


